import { roleConstants } from '../constants/index.js'
import { getFormatRoleOptions,getFormatTenantOptions } from '../../utils'

export const RoleAll = (state = {}, action) => {
    switch (action.type) {
        case roleConstants.GET_ROLES_REQUEST:
            return {
                loading: true,
                items: undefined,
                error: undefined
            }
            //break;
        case roleConstants.GET_ROLES_SUCCESS:
            return {
                loading: false,
                items: action.roleData.Body,
                itemsOptions: getFormatRoleOptions(action.roleData.Body),
                error: undefined
            }
            //break;
        case roleConstants.GET_ROLES_FAILURE:
            return {
                loading: false,
                items: undefined,
                error: action.error
            }
            //break;
        default:
            return state
    }
}

export const GetTenantsData = (state = {}, action) => {
    switch (action.type) {
        case roleConstants.GET_TENANTS_REQUEST:
            return {
                loading: true,
                items: undefined,
                error: undefined
            }
            //break;
        case roleConstants.GET_TENANTS_SUCCESS:
            return {
                loading: false,
                items: action.roleData.Body,
                itemsOptions: getFormatTenantOptions(action.roleData.Body),
                error: undefined
            }
            //break;
        case roleConstants.GET_TENANTS_FAILURE:
            return {
                loading: false,
                items: undefined,
                error: action.error
            }
            //break;
        default:
            return state
    }
}